<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path :fill="colorx" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    </svg>
</template>

<script>
export default {
    data: () => ({

    }),
    props: {
        colorx: {
        type: String,
        default: '#89899B'
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/icons/HomeIcon.vue